import { SHIPPING_PAGE } from '../constants/analytics';
import { IAnalyticsEvent } from '../types/analytics';

export const page = (pageName?: string) => ({
  hitType: 'pageview',
  page: pageName,
});

export const event = ({ eventAction, eventLabel, eventValue }: IAnalyticsEvent) => ({
  hitType: 'event',
  eventCategory: SHIPPING_PAGE,
  ...(eventAction ? { eventAction } : {}),
  ...(eventLabel ? { eventLabel } : {}),
  ...(eventValue ? { eventValue } : {}),
});

// JSON.stringify(new Error()) is '{}' — message and stack are non-enumerable
const serializeError = (error: any) =>
  JSON.stringify(error instanceof Error ? { name: error.name, message: error.message, stack: error.stack } : error);

export const exception = (error: any) => ({
  hitType: 'exception',
  exDescription: serializeError(error),
  isFatal: true,
});

export const apiException = (error: any) => ({
  hitType: 'exception',
  exDescription: serializeError(error),
  isFatal: false,
});
